import { render } from "./Advantages.vue?vue&type=template&id=bc6c71b2&scoped=true"
const script = {}

import "./Advantages.vue?vue&type=style&index=0&id=bc6c71b2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc6c71b2"]])

export default __exports__